import * as React from 'react';

import arrayMove from 'array-move';

import { SortableContainer, SortEnd } from 'react-sortable-hoc';

import SimpleTrack from '@common/types/release/simple-track';
import { AssetUpload } from '@webapp/types/assets/asset-upload';
import { UpdateTrackOrder } from '@webapp/store/tracks/action-creators';
import { TrackOrderUpdate } from '@services/track/types/track-order-update';

import TrackSidebarItem from '../track-sidebar/track-sidebar-item';
import { AssetValidationResults } from '@services/asset/types/asset-validation-results';

interface TrackSidebarItemsProps {
  className?: string;
  tracks: [
    SimpleTrack,
    AssetUpload | undefined,
    string,
    AssetValidationResults | undefined,
    boolean
  ][];
  releaseId?: string;
  artistId?: string;
  disabled?: boolean;
  location: any;
  updateOrder: (order: TrackOrderUpdate[]) => UpdateTrackOrder;
  onRemove: (trackId: string, isActive: boolean) => void;

  disableRemove?: boolean;
  routePrefix?: string;
  hideRemoveOption?: boolean;
  disableSorting?: boolean;
}

export const TrackSidebarItems: React.FC<TrackSidebarItemsProps> = (props) => {
  return (
    <div>
      {props.tracks.map(
        ([track, asset, title, assetStatus, isOwnerShipValid], i) => (
          <TrackSidebarItem
            key={`track-${track.id}`}
            index={i}
            trackId={track.id}
            title={title}
            order={track.order}
            isInstrumental={track.type === 'instrumental'}
            isExplicit={!!track.isExplicit}
            isClean={!!track.isClean}
            isInstantGratification={track.isInstantGratification}
            // TODO: DEVTEAM-958 - NFT - This need to be integrated to the track.
            // isNFTExlusive={!!track.isNFTExlusive}
            isUploading={asset?.status === 'uploading'}
            hasErrors={
              track?.status === 'invalid' ||
              assetStatus?.isValid === false ||
              (!isOwnerShipValid && !!assetStatus)
            }
            hideRemoveOption={props.hideRemoveOption}
            progress={asset?.progress || 0}
            artistId={props.artistId}
            releaseId={props.releaseId}
            location={props.location}
            disabled={props.disabled}
            onRemove={props.onRemove}
            disableRemove={props.disableRemove}
            routePrefix={props.routePrefix}
            disableSorting={props.disableSorting}
          />
        )
      )}
    </div>
  );
};

const SortableTrackSidebar =
  SortableContainer<TrackSidebarItemsProps>(TrackSidebarItems);

const ConnectedTrackSideBar = (props: TrackSidebarItemsProps) => {
  if (props.disableSorting) {
    return <TrackSidebarItems {...props} />;
  }

  const updateTracksOrder = ({ oldIndex, newIndex }: SortEnd) => {
    const tracks = props.tracks.map((t) => t[0]);
    const newTracks = arrayMove(tracks, oldIndex, newIndex);
    const newOrder = newTracks.map((t, i) => ({
      id: t.id as string,
      order: i + 1,
    }));

    props.updateOrder(newOrder);
  };

  return (
    <SortableTrackSidebar
      {...props}
      lockAxis="y"
      useDragHandle
      helperClass="sorting"
      lockToContainerEdges={true}
      onSortEnd={(newSort) => updateTracksOrder(newSort)}
    />
  );
};

export default ConnectedTrackSideBar;
